module.exports = __webpack_public_path__ + "img/c54dbc0.png";